import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

const mobileNav = document.querySelector('[data-mobile-nav]')
const mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]')
const mobileNavPanels = Array.from(mobileNav.querySelectorAll('[data-panel]'))
const mobileNavPanelToggles = mobileNav.querySelectorAll('[data-target-panel]')
const mobileNavBack = mobileNav.querySelectorAll('[data-back]')
const mobileNavPanelsState = ['main']

/**
 *
 */
const openMobileNav = () => {
    document.body.dataset.mobileNavOpen = 'true'
    disableBodyScroll(mobileNav)
    document.addEventListener('keydown', handleEscape)
    document.addEventListener('click', handleClickOutside)
}

/**
 *
 */
const closeMobileNav = () => {
    delete document.body.dataset.mobileNavOpen
    enableBodyScroll(mobileNav)
    document.removeEventListener('keydown', handleEscape)
    document.removeEventListener('click', handleClickOutside)
}

const handleEscape = (event) => {
    if (event.key === 'Escape') closeMobileNav()
}

const handleClickOutside = (event) => {
    if (!event.target.closest('[data-mobile-nav]') && !event.target.closest('[data-mobile-nav-toggle]')) closeMobileNav()
}

const updateNavState = () => {
    const [targetPanel] = [...mobileNavPanelsState].reverse()
    mobileNavPanels.forEach(panel => delete panel.dataset.active)
    mobileNav.querySelector(`[data-panel="${targetPanel}"]`).dataset.active = 'true'
}
if (mobileNavToggle) {
    mobileNavToggle.addEventListener('click', () => {
        if (document.body.dataset.mobileNavOpen) closeMobileNav()
        else openMobileNav()
    })
}

mobileNavPanelToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
        mobileNavPanelsState.push(toggle.dataset.targetPanel)
        updateNavState()
    })
})

mobileNavBack.forEach((backButton) => {
    backButton.addEventListener('click', () => {
        mobileNavPanelsState.pop()
        updateNavState()
    })
})
